export default {
  'global.action.view': 'View',
  'global.action.download': 'Download',
  'global.action.cash': 'Cash',
  'global.action.cashusdt': 'USDT',
  'global.action.logs': 'Logs',
  'global.message.success': 'Operation successful',
  'global.message.error': 'Operation error',
};